import { FC } from "react";
import { TransactionData, Transactions } from "./transactions";
import { ComponentQueryLoader } from "../../../../../../../shared/component-query-loader";
import { 
  CasesCredentialVerificationV1TransactionsContainerCredentialVerificationCaseV1Document,
  CredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactions,
} from "../../../../../../../../generated";
import { useQuery } from "@apollo/client";
import { Empty, Skeleton } from "antd";

interface TransactionContainerProps {
  caseId: string;
}

export const TransactionsContainer: FC<TransactionContainerProps> = ({caseId}) => {
  const {
    data: financeData,
    loading: financeLoading,
    error: financeError,
  } = useQuery(CasesCredentialVerificationV1TransactionsContainerCredentialVerificationCaseV1Document, {
    variables: {
      credentialVerificationCaseV1Id: caseId,
    },
  });

  if (financeLoading) {
    return <Skeleton active />;
  }

  if (financeError) {
    return (
      <Empty description="There was an error loading the data. Please try again!" />
    );
  }

  // calculate total amount
  let totalSentAmount = 0;
  let totalReceivedAmount = 0;
  let totalAmount = 0;
  if (financeData?.credentialVerificationCaseV1?.financeDetails?.transactions) {
    const finance =
      financeData.credentialVerificationCaseV1.financeDetails.transactions ??
      null;
    if (finance) {
      if (finance?.adhocTransactions?.length) {
        totalAmount = finance?.adhocTransactions?.
        filter(transaction => {
          const approval = transaction?.approval;
          const transactionRef = transaction?.transactionReference;
          return !((approval?.isApplicantApprovalRequired === true && approval?.isApplicantApproved !== true) || (transactionRef?.isSuccess === false))
        }).reduce((acc, transaction) => {
          const amount = transaction?.amount;
          if (amount !== undefined && amount !== null) {
            if (amount > 0) {
              totalSentAmount += amount;
            } else if (amount < 0) {
              totalReceivedAmount += Math.abs(amount); // Add to total received if negative
            }
            return acc + amount; // includes both positive and negative
          }
          return acc;
        }, 0);
      }
      if (finance?.submission) {
        const submissionAmount = finance?.submission?.amount ?? 0;
        totalSentAmount += submissionAmount;
      }
    }
  }

  console.log("total amount: ", totalAmount)

  const submissionTransaction: CredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactions =
  {
    amount:
      financeData?.credentialVerificationCaseV1?.financeDetails?.transactions
        ?.submission?.amount ?? undefined,
    reason: `Credential Verification Request`,
    createdAt:
      financeData?.credentialVerificationCaseV1?.financeDetails?.transactions
        ?.submission?.transactionReference?.completedAt,
    transactionReference: {
      referenceId:
        financeData?.credentialVerificationCaseV1?.financeDetails?.transactions
          ?.submission?.transactionReference?.referenceId,
    },
    id: caseId,
  };

  const transactionData: TransactionData = {
    totalReceived: totalReceivedAmount,
    totalSent: totalSentAmount,
    tableData: [
      ...(financeData?.credentialVerificationCaseV1?.financeDetails?.transactions?.adhocTransactions?.filter(
        (
          item
        ): item is CredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactions =>{
          const approval = item?.approval;
          const transactionRef = item?.transactionReference;
          return item !== null && item !== undefined && !((approval?.isApplicantApprovalRequired === true && approval?.isApplicantApproved !== true) || (transactionRef?.isSuccess === false))
        }
      ) || []),
      submissionTransaction,
    ],
  };

  return (
    <ComponentQueryLoader
      loading={false}
      hasData={transactionData !== undefined}
      hasDataComponent={<Transactions data={transactionData} />}
    />
  );
};

